import React, { createContext, useContext, useMemo } from "react";
import { useConsentFormTemplate } from "../hooks/useConsentFormTemplate";

const ConsentFormContext = createContext(null);

export function ConsentFormProvider({ children }) {
  const { template, ready } = useConsentFormTemplate();

  const value = useMemo(() => ({
    template,
    ready,
  }), [template, ready]);

  return (
    <ConsentFormContext.Provider value={value}>
      {children}
    </ConsentFormContext.Provider>
  );
}

export function useConsentForm() {
  const ctx = useContext(ConsentFormContext);
  if (!ctx) {
    throw new Error("useConsentForm must be used within ConsentFormProvider");
  }
  return ctx;
}

export default ConsentFormContext;
